(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-section-replacement"] && !window.DesignMode) return;
  try {
    
  // Function to process the table and add buttons
  function convertTableToDivs(table) {
    // Create a container div for the new structure
    const container = document.createElement('div');
    container.classList.add('div-table');

    // Process the table header (thead)
    const thead = table.querySelector('thead');
    if (thead) {
      const headerRow = document.createElement('div');
      headerRow.classList.add('div-table-header');

      Array.from(thead.rows[0].cells).forEach((cell) => {
        const headerCell = document.createElement('div');
        headerCell.classList.add('div-table-cell', 'header-cell');
        headerCell.textContent = cell.textContent;
        headerRow.appendChild(headerCell);
      });

      container.appendChild(headerRow);
    }

    // Process the table body (tbody)
    const tbody = table.querySelector('tbody');
    if (tbody) {
      Array.from(tbody.rows).forEach((row, rowIndex) => {
        const rowDiv = document.createElement('div');
        rowDiv.classList.add('div-table-row');

        Array.from(row.cells).forEach((cell, index) => {
          const cellDiv = document.createElement('div');
          cellDiv.classList.add('div-table-cell');

          // Add special styling or wrapper for the last column
          if (index === row.cells.length - 1 && rowIndex > 0) {
            cellDiv.classList.add('last-column');
            const value = cell.textContent.trim();
            // Check if the value is a product ID (numeric) or status text
            if (!isNaN(value)) {
              // If it's a product ID, add a "Buy Now" button
              cellDiv.innerHTML = `<button class="buy-now buy-now-custom" data-product-id="${value}">Buy Now</button>`;
            } else {
              // If it's status text, add a "discontinue" button
              cellDiv.innerHTML = `<button class="discontinue" data-status="${value}">${value}</button>`;
            }
          } else {
            cellDiv.textContent = cell.textContent;
          }

          rowDiv.appendChild(cellDiv);
        });

        container.appendChild(rowDiv);
      });
    }

    // Replace the original table with the new div-based structure
    table.parentNode.replaceChild(container, table);
  }

  // Find the table and convert it
  const table = document.querySelector('.replacement-table');
  if (table) {
    convertTableToDivs(table);
  }

  async function addToCart(productId, quantity = 1) {
    try {
      // Add the product to the cart using AJAX
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: productId, // Variant ID of the product
              quantity: quantity
            },
          ],
        }),
      });
  
      if (!response.ok) {
        throw new Error("Failed to add product to cart.");
      }
  
      const cartData = await response.json();
      console.log("Product added to cart:", cartData); 
      alert("Product added to cart successfully!");
    } catch (error) {
      console.error(error);
      alert("Error adding product to cart.");
    }
  }
  

  // Add event listeners for the buttons (optional)
  document.addEventListener('click', (event) => {
    if (event.target.classList.contains('buy-now-custom')) {
      const productId = event.target.getAttribute('data-product-id');
      addToCart(productId);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-deals"] && !window.DesignMode) return;
  try {
    
let currentDealIndex = 1;
 function updateDealProgress() {
    const dots = document.querySelectorAll('.new-deals-section .progress-indicator .dot');
    dots.forEach((dot, index) => {
      if (index + 1 === currentDealIndex) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }
  document.addEventListener('DOMContentLoaded', function() {
    const dealBlocks = document.querySelectorAll('.new-deals-section .deal-block');
    if (dealBlocks.length > 0) {
      dealBlocks[0].classList.add('active');
      // Generate progress indicator dots
      const progressIndicator = document.querySelector('.new-deals-section .progress-indicator');
      for (let i = 1; i <= dealBlocks.length; i++) {
        const dot = document.createElement('span');
        dot.classList.add('dot');
        progressIndicator.appendChild(dot);
      }
      updateDealProgress();
    }

    setInterval(() => {
      if (currentDealIndex < dealBlocks.length) {
        dealBlocks[currentDealIndex - 1].classList.remove('active');
        dealBlocks[currentDealIndex].classList.add('active');
        currentDealIndex++;
      } else {
        dealBlocks[currentDealIndex - 1].classList.remove('active');
        dealBlocks[0].classList.add('active');
        currentDealIndex = 1;
      }
      updateDealProgress();
    }, 5000);

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-logo"] && !window.DesignMode) return;
  try {
    
  class Ticker {
    constructor(element) {
      this.track = element;
      this.content = element.querySelector('.ticker-content');
      this.speed = parseInt(element.closest('.ticker-section').dataset.speed) || 3;
      this.delay = parseInt(element.closest('.ticker-section').dataset.delay) || 2;
      this.init();
    }

    init() {
      // Clone items for seamless loop
      const clone = this.content.cloneNode(true);
      this.track.appendChild(clone);

      // Calculate animation duration based on content width
      const contentWidth = this.content.offsetWidth;
      const duration = (contentWidth / 100) * this.speed;

      // Set animation
      setTimeout(() => {
        this.content.style.animation = `ticker ${duration}s linear infinite`;
        clone.style.animation = `ticker ${duration}s linear infinite`;
      }, this.delay * 1000);

      // Pause on hover
      this.track.addEventListener('mouseenter', () => {
        this.content.style.animationPlayState = 'paused';
        clone.style.animationPlayState = 'paused';
      });

      this.track.addEventListener('mouseleave', () => {
        this.content.style.animationPlayState = 'running';
        clone.style.animationPlayState = 'running';
      });
    }
  }

  // Initialize tickers
  document.addEventListener('DOMContentLoaded', () => {
    const tickers = document.querySelectorAll('[data-ticker]');
    tickers.forEach((ticker) => new Ticker(ticker));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-search-area"] && !window.DesignMode) return;
  try {
    
  // Add any JavaScript code here (if needed)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-ticker"] && !window.DesignMode) return;
  try {
    
  class Ticker {
    constructor(element) {
      this.track = element;
      this.content = element.querySelector('.ticker-content');
      this.speed = parseInt(element.closest('.ticker-section').dataset.speed) || 3;
      this.delay = parseInt(element.closest('.ticker-section').dataset.delay) || 2;
      this.init();
    }

    init() {
      // Clone items for seamless loop
      const clone = this.content.cloneNode(true);
      this.track.appendChild(clone);

      // Calculate animation duration based on content width
      const contentWidth = this.content.offsetWidth;
      const duration = (contentWidth / 100) * this.speed;

      // Set animation
      setTimeout(() => {
        this.content.style.animation = `ticker ${duration}s linear infinite`;
        clone.style.animation = `ticker ${duration}s linear infinite`;
      }, this.delay * 1000);

      // Pause on hover
      this.track.addEventListener('mouseenter', () => {
        this.content.style.animationPlayState = 'paused';
        clone.style.animationPlayState = 'paused';
      });

      this.track.addEventListener('mouseleave', () => {
        this.content.style.animationPlayState = 'running';
        clone.style.animationPlayState = 'running';
      });
    }
  }

  // Initialize tickers
  document.addEventListener('DOMContentLoaded', () => {
    const tickers = document.querySelectorAll('[data-ticker]');
    tickers.forEach((ticker) => new Ticker(ticker));
  });

  } catch(e) { console.error(e); }
})();
})();
